import { Modal } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import Styles from "./PermissionModal.module.css";
import { Close } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAllPermissions,
  fetchUserPermissions,
} from "../../../../Redux/Slices/companyAdminSlice";
import {
  addUserPermission,
  removeUserPermissions,
} from "../../../../Services/CompanyAdmin/AllApiAdmin";
import {
  ErrorMessage,
  SuccessMessage,
} from "../../../../commons/Toast/ErrorMessage";

const PermissionModal = ({
  open,
  handleClose,
  entityId,
  entityType,
  selectedEntity,
  selectedUser,
  userId,
}) => {
  const dispatch = useDispatch();
  const { permissionsList, permissions, loading } = useSelector(
    (state) => state.companyAdminSlice
  );
  const effectRan = useRef(false);

  const [selectedPermissions, setSelectedPermissions] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [allPermissions, setAllPermissions] = useState([]);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [initialServerPermissions, setInitialServerPermissions] = useState([]);

  const [remPer, setRemPer] = useState([]);

  const permissionDisplayNames = {
    EDIT_USER: "Edit User",
    EDIT_COMPANY: "Edit Company",
    EDIT_CONSUMER: "Edit Consumer",
    EDIT_GENERATOR: "Edit Generator",
    ALTER_ROLE_PERMISSION: "Alter Role Permission",
    EDIT_BANK_DETAILS: "Edit Bank Details",
    EDIT_ADDRESS: "Edit Address",
  };

  const permissionIdMapping = {
    EDIT_USER: 1,
    EDIT_COMPANY: 2,
    EDIT_CONSUMER: 3,
    EDIT_GENERATOR: 4,
    ALTER_ROLE_PERMISSION: 5,
    EDIT_BANK_DETAILS: 6,
    EDIT_ADDRESS: 7,
  };

  useEffect(() => {
    if (open && userId && !effectRan.current) {
      dispatch(fetchAllPermissions());
      dispatch(fetchUserPermissions(userId));
      effectRan.current = true;
    }
  }, [open, userId, dispatch]);

  useEffect(() => {
    if (!open) {
      effectRan.current = false;
      setIsInitialLoad(true);
      setSelectedPermissions({});
      setInitialServerPermissions([]);
    }
  }, [open]);

  useEffect(() => {
    if (permissionsList && permissionsList.length > 0) {
      setAllPermissions(permissionsList);

      if (isInitialLoad) {
        const userCurrentPermissions = permissions || [];
        const userPermissionNames = userCurrentPermissions.map(
          (p) => p.permission || p
        );
        setInitialServerPermissions(userPermissionNames);

        const initialPermissions = {};
        permissionsList.forEach((permission) => {
          const permissionName = permission.permission || permission;
          initialPermissions[permissionName] = true;
        });

        setSelectedPermissions(initialPermissions);
        setIsInitialLoad(false);
      }
    }
  }, [permissionsList, permissions, isInitialLoad]);

  useEffect(() => {
    if (permissions && permissions.length >= 0 && !isInitialLoad) {
      const userPermissionNames = permissions.map((p) => p.permission || p);
      setInitialServerPermissions(userPermissionNames);
    }
  }, [permissions, isInitialLoad]);

  const handlePermissionChange = (permission) => {
    setRemPer((prevPermissions) => {
      if (prevPermissions.includes(permissionIdMapping[permission])) {
        return prevPermissions.filter((p) => p !== permission);
      } else {
        return [...prevPermissions, permissionIdMapping[permission]];
      }
    });
    setSelectedPermissions((prev) => ({
      ...prev,
      [permission]: !prev[permission],
    }));
  };

  const handleSubmit = async () => {
    if (remPer?.length > 0) {
      let res = await removeUserPermissions(userId, remPer);
      if (res?.data?.code === 200) {
        SuccessMessage(res?.data?.message);
        dispatch(fetchUserPermissions(userId));
      } else {
        ErrorMessage(res?.data?.error);
      }
      return;
    }

    if (!userId || isSubmitting) return;

    setIsSubmitting(true);

    try {
      const currentlySelectedPermissions = Object.keys(
        selectedPermissions
      ).filter((permission) => selectedPermissions[permission] === true);

      const permissionsToAdd = currentlySelectedPermissions.filter(
        (permission) => !initialServerPermissions.includes(permission)
      );

      const permissionsToRemove = initialServerPermissions.filter(
        (permission) => !currentlySelectedPermissions.includes(permission)
      );

    

      if (permissionsToAdd.length > 0) {
        const permissionIdsToAdd = permissionsToAdd
          .map((permission) => permissionIdMapping[permission])
          .filter((id) => id !== undefined);

        if (permissionIdsToAdd.length > 0) {
          await addUserPermission(userId, permissionIdsToAdd);
        }
      }

      if (permissionsToRemove.length > 0) {
        const permissionIdsToRemove = permissionsToRemove
          .map((permission) => permissionIdMapping[permission])
          .filter((id) => id !== undefined);

        if (permissionIdsToRemove.length > 0) {
          await removeUserPermissions(userId, permissionIdsToRemove);
        }
      }

      if (permissionsToAdd.length > 0 || permissionsToRemove.length > 0) {
        await dispatch(fetchUserPermissions(userId));
        const updatedPermissions = currentlySelectedPermissions;
        setInitialServerPermissions(updatedPermissions);
      }

      // handleClose();
    } catch (error) {
      console.error("Error updating permissions:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <div className={`popupModal ${Styles.createEditModalCont}`}>
          <div
            className={`display_flex_row modalHeading ${Styles.modalHeading}`}
          >
            <div className={`headingText ${Styles.headingSec}`}>
              {selectedUser?.fullName || selectedUser?.username || "User"}{" "}
              <span className={Styles.secHead}>{entityType}</span>
            </div>
            <Close
              style={{ fontSize: 24, color: "#777777", cursor: "pointer" }}
              onClick={handleClose}
            />
          </div>
          <div className={` display_flex_row_center ${Styles.userSection}`}>
            <div
              className={`display_flex_row_center ${Styles.userPermissionContent}`}
            >
              {loading ? (
                <div>Loading permissions...</div>
              ) : allPermissions && allPermissions.length > 0 ? (
                <div className={`scroll_bar_y ${Styles.mainUserContent}`}>
                  <div className={Styles.userPerContent}>
                    {allPermissions.map((permission, index) => {
                      const permissionName =
                        permission.permission || permission;
                      return (
                        <div
                          key={permissionName || index}
                          className={Styles.userPermissionCont}
                        >
                          <input
                            type="checkbox"
                            id={`permission-${index}`}
                            checked={
                              selectedPermissions[permissionName] || false
                            }
                            onChange={() =>
                              handlePermissionChange(permissionName)
                            }
                            className={Styles.companyUser}
                          />
                          <label
                            htmlFor={`permission-${index}`}
                            className={Styles.perHead}
                          >
                            {permissionDisplayNames[permissionName] ||
                              permissionName
                                .replace(/_/g, " ")
                                .toLowerCase()
                                .replace(/\b\w/g, (l) => l.toUpperCase())}
                          </label>
                        </div>
                      );
                    })}
                  </div>
                </div>
              ) : (
                <div
                  style={{
                    padding: "40px",
                    textAlign: "center",
                    color: "#666",
                  }}
                >
                  No permissions found for this user.
                </div>
              )}
            </div>
          </div>
          <div
            className={`display_flex_row_center ${Styles.submitButtonSection}`}
          >
            <div
              className={`display_flex_row_center ${Styles.submitText}`}
              onClick={handleSubmit}
              style={{
                cursor: isSubmitting ? "not-allowed" : "pointer",
                opacity: isSubmitting ? 0.6 : 1,
                pointerEvents: isSubmitting ? "none" : "auto",
              }}
            >
              {isSubmitting ? "Updating..." : "Submit"}
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default PermissionModal;
